import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';
import {
    FaShoppingCart, FaBrain, FaBullhorn, FaStore, FaUsers,
    FaChartLine, FaRobot, FaCode, FaDatabase, FaAd, FaRocket
} from 'react-icons/fa';

const Services = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const services = [
        {
            id: 1,
            icon: <FaShoppingCart />,
            title: "E-commerce Development & Strategy",
            description: "Complete e-commerce solutions from concept to launch, with focus on conversion and growth.",
            offerings: [
                {
                    icon: <FaStore />,
                    title: "End-to-End Store Creation",
                    description: "Designing and developing fully functional e-commerce platforms for various niches (watches, accessories, retail)."
                },
                {
                    icon: <FaUsers />,
                    title: "Digital Brand Identity",
                    description: "Building and managing professional business presence on social media platforms (Facebook, Instagram) to drive traffic."
                },
                {
                    icon: <FaChartLine />,
                    title: "Conversion Rate Optimization (CRO)",
                    description: "Enhancing User Experience (UX) and store layouts to turn visitors into loyal customers."
                },
                {
                    icon: <FaRocket />,
                    title: "E-commerce Consulting",
                    description: "Providing strategic advice for startups on how to launch and scale online stores from scratch."
                }
            ]
        },
        {
            id: 2,
            icon: <FaBrain />,
            title: "AI & Deep Learning Solutions",
            description: "Advanced AI and machine learning solutions for real-world business applications.",
            offerings: [
                {
                    icon: <FaRobot />,
                    title: "Computer Vision Development",
                    description: "Building advanced image recognition and classification models (e.g., Agricultural disease detection systems)."
                },
                {
                    icon: <FaCode />,
                    title: "Model Deployment",
                    description: "Transforming raw AI models into functional Web Applications, making complex algorithms accessible to end-users."
                },
                {
                    icon: <FaDatabase />,
                    title: "Data Analysis & Insights",
                    description: "Processing large datasets (Kaggle-sourced or custom) to extract actionable technical patterns and predictions."
                }
            ]
        },
        {
            id: 3,
            icon: <FaBullhorn />,
            title: "Digital Marketing & Growth",
            description: "Strategic marketing solutions to boost your online presence and drive business growth.",
            offerings: [
                {
                    icon: <FaAd />,
                    title: "Social Media Advertising",
                    description: "Managing paid ad campaigns to boost sales and brand awareness for online businesses."
                },
                {
                    icon: <FaChartLine />,
                    title: "Market Positioning",
                    description: "Crafting digital strategies to help new brands compete effectively in the market."
                }
            ]
        }
    ];

    return (
        <section className="services" id="services">
            <div className="services-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container services-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        Professional <span className="gradient-text">Services</span>
                    </h2>
                    <p className="section-subtitle">
                        Comprehensive solutions tailored to your business needs
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div
                            className="service-card"
                            key={service.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="service-header">
                                <div className="service-icon">{service.icon}</div>
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                            </div>

                            <div className="service-offerings">
                                {service.offerings.map((offering, idx) => (
                                    <div className="offering-item" key={idx}>
                                        <div className="offering-icon">{offering.icon}</div>
                                        <div className="offering-content">
                                            <h4 className="offering-title">{offering.title}</h4>
                                            <p className="offering-description">{offering.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="services-cta" data-aos="fade-up" data-aos-delay="400">
                    <h3 className="cta-title">Ready to start your project?</h3>
                    <p className="cta-description">Let's work together to bring your ideas to life</p>
                    <a href="#contact" className="cta-button">
                        Get In Touch
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Services;
